module.exports = __webpack_public_path__ + "img/ic_file-check-purple.46fc312f.svg";